module.exports = __webpack_public_path__ + "img/quotes.1272111a.svg";